import { render, staticRenderFns } from "./LoginDesktop.vue?vue&type=template&id=ddbc3f26&scoped=true"
import script from "./LoginDesktop.vue?vue&type=script&lang=js"
export * from "./LoginDesktop.vue?vue&type=script&lang=js"
import style0 from "./LoginDesktop.vue?vue&type=style&index=0&id=ddbc3f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbc3f26",
  null
  
)

export default component.exports